import {get, post} from '@/axios'

//获取售后维修单一览
export const getPageList = p => post('saleAdmin/getPageList', p);
//获取售后维修单详情
export const select = p => get('saleAdmin/select', p);
//更新售后维修单
export const update = p => post('saleAdmin/update', p);
// 获取快递公司一览
export const getExpressList = p => post('express/getList', p);
// 获取运单详情
export const getExpressInfo = p => get('express/getExpressInfo', p);
//确认收货，添加订单号
export const setSerialNumber = p => get('saleAdmin/setSerialNumber', p);
//更改状态为报价中
export const updateOffer = p => post('saleAdmin/updateOffer', p);
//更改付款状态
export const changePay = p => post('saleAdmin/changePay', p);
//获取历史维修记录
export const getHisList = p => post('saleAdmin/getHisList', p);
//更新设备故障信息
export const updateDeviceError = p => post('saleAdmin/updateDeviceFault', p);



// WEBPACK FOOTER //
// ./src/api/saleAdmin.js